import { createSelector } from "@reduxjs/toolkit";
import compact from "lodash/compact";
import { useAppSelector } from "../store";

const selectSavedItemsIds = (state: any) => state.sections.savedItemsIds;
const selectCourses = (state: any) => state.sections.courses;

const selectSectionCourses = (coursesIds: string[]) =>
  createSelector(selectCourses, courses => compact(coursesIds.map(id => courses[id])));

const selectSavedItems = createSelector(selectSavedItemsIds, selectCourses, (savedItemsIds, courses) =>
  compact(savedItemsIds.map((productId: string) => courses[productId]))
);

export const useNavigation = () => useAppSelector(state => state.navigation);
export const useUser = () => useAppSelector(state => state.user);
export const useSections = () => useAppSelector(state => state.sections);
export const useCart = () => useAppSelector(state => state.cart);
export const useCourses = () => useAppSelector(state => state.courses);
export const useActiveFeatureFlags = () => useAppSelector(state => state.activeFeatureFlags);
export const useSectionCourses = (coursesIds: string[]) =>
  useAppSelector(state => selectSectionCourses(coursesIds)(state));
export const useSavedItems = () => useAppSelector(state => selectSavedItems(state));
